import React from 'react';
import classNames from 'classnames';
import './GameButton.styles.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';


type buttonProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void,
  children: React.ReactNode
  color?: 'primary' | 'secondary',
  id?: string,
  className?: string,
  size?: 'small' | 'large',
  tooltip?: string,
  isLoading?: boolean,
  isDisabled?: boolean,
  disabledTooltip?: string
}
const GameButton = ({ onClick, color, id, className, size, isDisabled, tooltip, disabledTooltip, isLoading, children }: buttonProps) => (
  <button 
    className={classNames("gameButton", (color || 'primary'), {'loading': isLoading}, {'disabled': isDisabled}, {'tooltip': !!tooltip}, size, className)} 
    id={id}
    onClick={isLoading ? ()=>{} : onClick}
    title={(isDisabled && disabledTooltip) ? disabledTooltip : tooltip}
    data-tooltip={(isDisabled && disabledTooltip) ? disabledTooltip : tooltip}
    disabled={isDisabled}    
  > {isLoading ? <FontAwesomeIcon icon={faSpinner} /> : children}</button>
);

export default GameButton;
